import React from "react";

const AmploButton = (props) => {
  const { hide, className, children } = props;

  const { onClick } = props;

  const handleClick = (e) => onClick();

  if (hide) {
    return null;
  }

  const _className = className
    ? className
    : "m-site-btn--primary primary-color-background";

  return (
    <button data-testid="t-AmploBu-button" className={_className} onClick={handleClick}>
      {children}
    </button>
  );
};

export default AmploButton;
